import '../../css/lp/integrator_mock_debug.scss';

function clone(value) {
    if (value === null || typeof value === 'undefined') {
        return value;
    }

    return JSON.parse(JSON.stringify(value));
}

function isObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function mergeDeep(baseValue, overrideValue) {
    if (!isObject(baseValue) || !isObject(overrideValue)) {
        return clone(typeof overrideValue === 'undefined' ? baseValue : overrideValue);
    }

    const merged = clone(baseValue) || {};
    Object.keys(overrideValue).forEach((key) => {
        merged[key] = mergeDeep(baseValue[key], overrideValue[key]);
    });

    return merged;
}

function parseDebugData() {
    const dataElement = document.getElementById('lp-integrator-mock-debug-data');
    if (!dataElement) {
        return null;
    }

    try {
        return JSON.parse(dataElement.textContent || '{}');
    } catch (error) {
        window.console.error('Failed to parse integrator mock debug data', error);
        return null;
    }
}

function getPresets(scenarioConfig) {
    return scenarioConfig && typeof scenarioConfig === 'object' && scenarioConfig.presets && typeof scenarioConfig.presets === 'object'
        ? scenarioConfig.presets
        : {};
}

function getDefaultScenarioKey(presets, scenarioConfig) {
    const presetKeys = Object.keys(presets);
    for (let index = 0; index < presetKeys.length; index += 1) {
        const presetKey = presetKeys[index];
        if (presets[presetKey] && presets[presetKey].default === true) {
            return presetKey;
        }
    }

    if (typeof scenarioConfig.default === 'string' && Object.prototype.hasOwnProperty.call(presets, scenarioConfig.default)) {
        return scenarioConfig.default;
    }

    return 'disabled';
}

function normalizeScenarioKey(value, presets, scenarioConfig) {
    const normalizedValue = typeof value === 'string' ? value.trim() : value;

    if (!normalizedValue) {
        return getDefaultScenarioKey(presets, scenarioConfig);
    }

    const lowerCaseValue = normalizedValue.toLowerCase();

    if (value === 'disabled') {
        return value;
    }

    if (lowerCaseValue === 'disabled') {
        return 'disabled';
    }

    if (Object.prototype.hasOwnProperty.call(presets, normalizedValue)) {
        return normalizedValue;
    }

    const presetKeys = Object.keys(presets);
    for (let index = 0; index < presetKeys.length; index += 1) {
        const presetKey = presetKeys[index];
        const preset = presets[presetKey] || {};

        if (presetKey.toLowerCase() === lowerCaseValue) {
            return presetKey;
        }

        if (typeof preset.label === 'string' && preset.label.toLowerCase() === lowerCaseValue) {
            return presetKey;
        }
    }

    return getDefaultScenarioKey(presets, scenarioConfig);
}

function getSelectedScenarioKey(url, storageKey, presets, scenarioConfig) {
    let selectedScenario = url.searchParams.get('mockScenario') || url.searchParams.get('debugScenario');

    if (selectedScenario) {
        selectedScenario = normalizeScenarioKey(selectedScenario, presets, scenarioConfig);
        sessionStorage.setItem(storageKey, selectedScenario);
        return selectedScenario;
    }

    return normalizeScenarioKey(sessionStorage.getItem(storageKey), presets, scenarioConfig);
}

function resolveMockConfig(isDebugEnabled, selectedScenario, defaultMockConfig, presets) {
    if (!isDebugEnabled) {
        return null;
    }

    if (selectedScenario === 'disabled') {
        return null;
    }

    if (!Object.prototype.hasOwnProperty.call(presets, selectedScenario)) {
        return null;
    }

    return mergeDeep(defaultMockConfig || {}, presets[selectedScenario].config || {});
}

function isPickerCollapsed(storageKey) {
    return sessionStorage.getItem(storageKey) === 'true';
}

function setPickerCollapsed(storageKey, isCollapsed) {
    sessionStorage.setItem(storageKey, isCollapsed ? 'true' : 'false');
}

function buildOptions(select, presets, selectedScenario) {
    const disabledOption = document.createElement('option');
    disabledOption.value = 'disabled';
    disabledOption.textContent = 'Disabled';
    disabledOption.selected = selectedScenario === 'disabled';
    select.appendChild(disabledOption);

    Object.keys(presets).forEach((key) => {
        const option = document.createElement('option');
        const preset = presets[key] || {};

        option.value = key;
        option.textContent = preset.label || key;
        option.selected = selectedScenario === key;
        select.appendChild(option);
    });
}

function updatePickerVisibility(panel, expandButton, isCollapsed) {
    panel.style.display = isCollapsed ? 'none' : 'block';
    expandButton.style.display = isCollapsed ? 'block' : 'none';
}

function renderPicker(context) {
    const {
        isDebugEnabled,
        presets,
        selectedScenario,
        resolvedMockConfig,
        storageKey,
        pickerCollapsedStorageKey,
        url,
    } = context;

    if (!isDebugEnabled || Object.keys(presets).length === 0) {
        return;
    }

    const container = document.getElementById('lp-integrator-mock-picker');
    const panel = document.getElementById('lp-integrator-mock-picker-panel');
    const select = document.getElementById('lp-integrator-mock-picker-select');
    const applyButton = document.getElementById('lp-integrator-mock-picker-apply');
    const resetButton = document.getElementById('lp-integrator-mock-picker-reset');
    const minimiseButton = document.getElementById('lp-integrator-mock-picker-minimise');
    const expandButton = document.getElementById('lp-integrator-mock-picker-expand');
    const status = document.getElementById('lp-integrator-mock-picker-status');

    if (!container || !panel || !select || !applyButton || !resetButton || !minimiseButton || !expandButton || !status) {
        return;
    }

    buildOptions(select, presets, selectedScenario);
    status.textContent = resolvedMockConfig && resolvedMockConfig.enabled ? 'Mocks active' : 'Mocks inactive';
    container.style.display = 'block';

    updatePickerVisibility(panel, expandButton, isPickerCollapsed(pickerCollapsedStorageKey));

    applyButton.addEventListener('click', () => {
        sessionStorage.setItem(storageKey, select.value);
        window.location.reload();
    });

    resetButton.addEventListener('click', () => {
        sessionStorage.removeItem(storageKey);
        url.searchParams.delete('mockScenario');
        window.location.href = url.toString();
    });

    minimiseButton.addEventListener('click', () => {
        setPickerCollapsed(pickerCollapsedStorageKey, true);
        updatePickerVisibility(panel, expandButton, true);
    });

    expandButton.addEventListener('click', () => {
        setPickerCollapsed(pickerCollapsedStorageKey, false);
        updatePickerVisibility(panel, expandButton, false);
    });
}

(function initIntegratorMockDebug() {
    const debugData = parseDebugData();
    if (!debugData) {
        return;
    }

    const debugOptions = debugData.debugOptions || {};
    const defaultMockConfig = debugOptions.integrator_mock || null;
    const scenarioConfig = debugOptions.integrator_mock_scenarios || {};
    const areMockScenariosEnabled = debugOptions.integrator_mock_scenarios_enabled !== false;
    const presets = getPresets(scenarioConfig);
    const storageKey = `lp.integrator_mock_scenario.${debugData.pageId}`;
    const pickerCollapsedStorageKey = `${storageKey}.collapsed`;
    const url = new URL(window.location.href);
    const isDebugEnabled = debugData.environment !== 'prod' || debugData.internalCall === true;
    const selectedScenario = areMockScenariosEnabled ? getSelectedScenarioKey(url, storageKey, presets, scenarioConfig) : null;
    const resolvedMockConfig = areMockScenariosEnabled ? resolveMockConfig(isDebugEnabled, selectedScenario, defaultMockConfig, presets) : null;

    window.__LP_INTEGRATOR_MOCK_DEBUG__ = {
        selectedScenario: isDebugEnabled && areMockScenariosEnabled ? selectedScenario : null,
        config: resolvedMockConfig,
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            renderPicker({
                isDebugEnabled: isDebugEnabled && areMockScenariosEnabled,
                presets,
                selectedScenario,
                resolvedMockConfig,
                storageKey,
                pickerCollapsedStorageKey,
                url,
            });
        });

        return;
    }

    renderPicker({
        isDebugEnabled: isDebugEnabled && areMockScenariosEnabled,
        presets,
        selectedScenario,
        resolvedMockConfig,
        storageKey,
        pickerCollapsedStorageKey,
        url,
    });
}());
